import { initVueAppOnLoad } from '@/app'
import App from '@/views/SiteHeader.vue'

initVueAppOnLoad('#site-nav-app', App)
